import { defineMessages, IntlShape } from "react-intl";

import ActivityCompanyOption from "@mapmycustomers/shared/enum/activity/ActivityCompanyOption";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [ActivityCompanyOption.ALL]: {
    id: "activityList.filter.company.any",
    defaultMessage: "Any Company",
    description: "Activity Company Option all",
  },
  [ActivityCompanyOption.HAS_COMPANY]: {
    id: "activityList.filter.company.notEmpty",
    defaultMessage: "Has Company",
    description: "Activity Company Option Has Company",
  },
  [ActivityCompanyOption.NO_COMPANY]: {
    id: "activityList.filter.company.empty",
    defaultMessage: "No Company",
    description: "Activity Company Option No Company",
  },
});

const getActivityCompanyOptionDisplayName = (
  intl: IntlShape,
  activityCompanyOption: ActivityCompanyOption
) => getDisplayName(intl, messages, activityCompanyOption, "ActivityCompanyOption");

export default getActivityCompanyOptionDisplayName;
